import React from 'react';
import { SectionType } from '../enums/SectionType';
import About from '../interfaces/AboutMe';
import Section from '../interfaces/Section';
import SocialMedia from '../interfaces/SocialMedia';
import Tech from '../interfaces/Tech';

interface IAppContext {
    fullName: string;
    description: string;
    username: string;
    sections: Section[];
    tech: Tech[];
    socialMedia: SocialMedia[];
    changeData: any;
    about: About[];
}

const defaultState = {
    fullName: '',
    description: '',
    username: '',
    sections: [
        { id: 3, name: 'github-streak', order: 3 },
        { id: 1, name: 'about-me', order: 1 },
        { id: 2, name: 'languages-and-tools', order: 2 },
        { id: 4, name: 'github-stats', order: 4 },
        { id: 0, name: 'github-trophy', order: 0 },
        { id: 5, name: 'connect-with-me', order: 5 }
    ],
    tech: [
        {
            id: 0,
            name: 'Java',
            imageUrl: '<a href="https://www.java.com/" target="_blank"><img src="https://i.postimg.cc/wtcrNd7c/java.png" alt="java"  height="40" /></a>',
            markdownUrl: '[![java.png](https://i.postimg.cc/k5kPkJCZ/java.png)](hhttps://www.java.com/)',
            choosed: false
        },
        {
            id: 1,
            name: 'Python',
            imageUrl: '<a href="https://www.python.org/" target="_blank"><img src="https://i.postimg.cc/WFYXmpjr/python.png" alt="python" height="40" /></a>',
            markdownUrl: '[![python.png](https://i.postimg.cc/mkBJsh5d/python.png)](https://www.python.org/)',
            choosed: false
        },
        {
            id: 2,
            name: 'JavaScript',
            imageUrl: '<a href="https://www.javascript.com/" target="_blank"><img src="https://i.postimg.cc/NywVL0fj/javascript.png" alt="javascript" height="40" /></a>',
            markdownUrl: '[![javascript.png](https://i.postimg.cc/YS4wn45Y/javascript.png)](https://www.javascript.com/)',
            choosed: false
        },
        {
            id: 3,
            name: 'PHP',
            imageUrl: '<a href="https://www.php.net/" target="_blank"><img src="https://i.postimg.cc/hfkZ3Gm1/php.png" alt="php" height="40" /></a>',
            markdownUrl: '[![php.png](https://i.postimg.cc/MpHkHMKN/php.png)](https://www.php.net/)',
            choosed: false
        },
        {
            id: 4,
            name: 'Kotlin',
            imageUrl: '<a href="https://kotlinlang.org/" target="_blank"><img src="https://i.postimg.cc/7fGQVz5L/kotlin.png" alt="kotlin" height="40" /></a>',
            markdownUrl: '[![kotlin.png](https://i.postimg.cc/4NBkXbZp/kotlin.png)](https://kotlinlang.org/)',
            choosed: false
        },
        {
            id: 5,
            name: 'Go Language',
            imageUrl: '<a href="https://go.dev/" target="_blank"><img src="https://i.postimg.cc/FYS89Sv6/go.png" alt="go" height="40" /></a>',
            markdownUrl: '[![go.png](https://i.postimg.cc/Bn70B5VJ/go.png)](https://go.dev/)',
            choosed: false
        },
        {
            id: 6,
            name: 'Swift',
            imageUrl: '<a href="https://www.swift.org/" target="_blank"><img src="https://i.postimg.cc/mtH8MGnz/swift.png" alt="swift" height="40" /></a>',
            markdownUrl: '[![swift.png](https://i.postimg.cc/Pr6cgXz4/swift.png)](https://www.swift.org/)',
            choosed: false
        },
        {
            id: 7,
            name: 'TypeScript',
            imageUrl: '<a href="https://www.typescriptlang.org/" target="_blank"><img src="https://i.postimg.cc/nMMdFmY1/typescript.png" alt="typescript" height="40" /></a>',
            markdownUrl: '[![typescript.png](https://i.postimg.cc/ZYxXLFWX/typescript.png)](https://www.typescriptlang.org/)',
            choosed: false
        },
        {
            id: 8,
            name: 'C++',
            imageUrl: '<a href="https://cplusplus.com/" target="_blank"><img src="https://i.postimg.cc/2L5gmXjd/c.png" alt="c" height="40" /></a>',
            markdownUrl: '[![c.png](https://i.postimg.cc/8cdGRqqY/c.png)](https://cplusplus.com/)',
            choosed: false
        },
        {
            id: 9,
            name: 'Ruby',
            imageUrl: '<a href="https://www.ruby-lang.org/" target="_blank"><img src="https://i.postimg.cc/pmMkJ6N0/ruby.png" alt="ruby" height="40" /></a>',
            markdownUrl: '[![ruby.png](https://i.postimg.cc/y8k5BMLz/ruby.png)](https://www.ruby-lang.org/)',
            choosed: false
        },
        {
            id: 10,
            name: '.Net',
            imageUrl: '<a href="https://dotnet.microsoft.com/" target="_blank"><img src="https://i.postimg.cc/bd6KL8Lm/dotnet.png" alt="dotnet" height="40" /></a>',
            markdownUrl: '[![dotnet.png](https://i.postimg.cc/rFcMVw42/dotnet.png)](https://dotnet.microsoft.com/)',
            choosed: false
        },
        {
            id: 11,
            name: 'Android',
            imageUrl: '<a href="https://www.android.com/" target="_blank"><img src="https://i.postimg.cc/PC8sPcW2/android.png" alt="android" height="40" /></a>',
            markdownUrl: '[![android.png](https://i.postimg.cc/zGxJPYVZ/android.png)](https://www.android.com/)',
            choosed: false
        },
        {
            id: 12,
            name: 'Firebase',
            imageUrl: '<a href="https://firebase.google.com" target="_blank"><img src="https://i.postimg.cc/f3n4XK5Z/firebase.png" alt="firebase" height="40" /></a>',
            markdownUrl: '[![firebase.png](https://i.postimg.cc/wB39C4mt/firebase.png)](https://firebase.google.com)',
            choosed: false
        },
        {
            id: 13,
            name: 'Angular',
            imageUrl: '<a href="https://angular.io" target="_blank"><img src="https://i.postimg.cc/qh49Dv95/angular.png" alt="angular" height="40" /></a>',
            markdownUrl: '[![angular.png](https://i.postimg.cc/JnkMnyKM/angular.png)](https://angular.io)',
            choosed: false
        },
        {
            id: 14,
            name: 'React',
            imageUrl: '<a href="https://reactjs.org" target="_blank"><img src="https://i.postimg.cc/hJgyc3pJ/react.png" alt="react" height="40" /></a>',
            markdownUrl: '[![react.png](https://i.postimg.cc/pd5gQwjB/react.png)](https://reactjs.org)',
            choosed: false
        },
        {
            id: 15,
            name: 'Vue',
            imageUrl: '<a href="https://vuejs.org" target="_blank"><img src="https://i.postimg.cc/QVPfHMfZ/vue.png" alt="vue" height="40" /></a>',
            markdownUrl: '[![vue.png](https://i.postimg.cc/X7Nm1GFq/vue.png)](https://vuejs.org)',
            choosed: false
        },
        {
            id: 16,
            name: 'Flutter',
            imageUrl: '<a href="https://flutter.dev" target="_blank"><img src="https://i.postimg.cc/v1WJvVSn/flutter.png" alt="flutter" height="40" /></a>',
            markdownUrl: '[![flutter.png](https://i.postimg.cc/bvMqp0xm/flutter.png)](https://flutter.dev)',
            choosed: false
        },
        {
            id: 17,
            name: 'Laravel',
            imageUrl: '<a href="https://laravel.com" target="_blank"><img src="https://i.postimg.cc/V05Z2r4D/laravel.png" alt="laravel" height="40" /></a>',
            markdownUrl: '[![laravel.png](https://i.postimg.cc/cCcqgf3y/laravel.png)](https://laravel.com)',
            choosed: false
        },
        {
            id: 18,
            name: 'NodeJs',
            imageUrl: '<a href="https://nodejs.org" target="_blank"><img src="https://i.postimg.cc/v452RdLF/nodejs.png" alt="nodejs" height="40" /></a>',
            markdownUrl: '[![nodejs.png](https://i.postimg.cc/t4MKxqsT/nodejs.png)](https://nodejs.org)',
            choosed: false
        },
        {
            id: 19,
            name: 'Spring',
            imageUrl: '<a href="https://spring.io" target="_blank"><img src="https://i.postimg.cc/3yBLRCct/spring.png" alt="spring" height="40" /></a>',
            markdownUrl: '[![spring.png](https://i.postimg.cc/NMhZdd7v/spring.png)](https://spring.io)',
            choosed: false
        },
        {
            id: 20,
            name: 'MySQL',
            imageUrl: '<a href="https://www.mysql.com" target="_blank"><img src="https://i.postimg.cc/t7mMWkCf/mysql.png" alt="mysql" height="40" /></a>',
            markdownUrl: '[![mysql.png](https://i.postimg.cc/Ghcn0S0c/mysql.png)](https://www.mysql.com)',
            choosed: false
        },
        {
            id: 21,
            name: 'Postgres SQL',
            imageUrl: '<a href="https://www.postgresql.org" target="_blank"><img src="https://i.postimg.cc/mzgmF1xB/postgres.png" alt="postgres" height="40" /></a>',
            markdownUrl: '[![postgres.png](https://i.postimg.cc/B6xkk2ML/postgres.png)](https://www.postgresql.org)',
            choosed: false
        },
        {
            id: 22,
            name: 'Mongo DB',
            imageUrl: '<a href="https://www.mongodb.com" target="_blank"><img src="https://i.postimg.cc/dD0fhpvr/mongodb.png" alt="mongodb" height="40" /></a>',
            markdownUrl: '[![mongodb.png](https://i.postimg.cc/66Vxmxmj/mongodb.png)](https://www.mongodb.com)',
            choosed: false
        },
        {
            id: 23,
            name: 'AWS',
            imageUrl: '<a href="https://aws.amazon.com" target="_blank"><img src="https://i.postimg.cc/TL0BzXxY/aws.png" alt="aws" height="40" /></a>',
            markdownUrl: '[![aws.png](https://i.postimg.cc/Bbfs1qwD/aws.png)](https://aws.amazon.com)',
            choosed: false
        },
        {
            id: 24,
            name: 'Google Cloud',
            imageUrl: '<a href="https://cloud.google.com" target="_blank"><img src="https://i.postimg.cc/dLpgPBbd/gcp.png" alt="gcp" height="40" /></a>',
            markdownUrl: '[![gcp.png](https://i.postimg.cc/Jzz8XYKT/gcp.png)](https://cloud.google.com)',
            choosed: false
        },
        {
            id: 25,
            name: 'Docker',
            imageUrl: '<a href="https://www.docker.com" target="_blank"><img src="https://i.postimg.cc/G93Wk9PB/docker.png" alt="docker" height="40" /></a>',
            markdownUrl: '[![docker.png](https://i.postimg.cc/Y2QtBWhx/docker.png)](https://www.docker.com)',
            choosed: false
        },
        {
            id: 26,
            name: 'Jenkins',
            imageUrl: '<a href="https://www.jenkins.io" target="_blank"><img src="https://i.postimg.cc/WF5f96md/jenkins.png" alt="jenkins" height="40" /></a>',
            markdownUrl: '[![jenkins.png](https://i.postimg.cc/9025QLrY/jenkins.png)](https://www.jenkins.io)',
            choosed: false
        },
        {
            id: 27,
            name: 'Trello',
            imageUrl: '<a href="https://trello.com" target="_blank"><img src="https://i.postimg.cc/2LqT0p8t/trello.png" alt="trello" height="40" /></a>',
            markdownUrl: '[![trello.png](https://i.postimg.cc/mkjq2BxT/trello.png)](https://trello.com)',
            choosed: false
        },
        {
            id: 28,
            name: 'Jira',
            imageUrl: '<a href="https://jira.atlassian.com" target="_blank"><img src="https://i.postimg.cc/XGjzcD5M/jira.png" alt="jira" height="40" /></a>',
            markdownUrl: '[![jira.png](https://i.postimg.cc/pTzMvwXd/jira.png)](https://jira.atlassian.com)',
            choosed: false
        },
        {
            id: 29,
            name: 'Git',
            imageUrl: '<a href="https://git-scm.com" target="_blank"><img src="https://i.postimg.cc/jLLBF9Ft/git.png" alt="git" height="40" /></a>',
            markdownUrl: '[![git.png](https://i.postimg.cc/8PHDjgdJ/git.png)](https://git-scm.com)',
            choosed: false
        },
    ],
    socialMedia: [
        {
            id: 0,
            name: 'Instagram',
            imageUrl: '<img src="https://i.postimg.cc/vgkCDqxW/instagram.png" alt="instagram" height="36"/>',
            markdownUrl: '[![instagram.png](https://i.postimg.cc/8czGKx1n/instagram.png)](https://postimg.cc/vgkCDqxW)',
            value: '',
            url: 'https://instagram.com/'
        },
        {
            id: 1,
            name: 'LinkedIn',
            imageUrl: '<img src="https://i.postimg.cc/kVj0PXnY/linkedin.png" alt="linkedin" height="36"/>',
            markdownUrl: '[![linkedin.png](https://i.postimg.cc/fLZDXJ1s/linkedin.png)](https://postimg.cc/kVj0PXnY)',
            value: '',
            url: 'https://linkedin.com/in/'
        },
        {
            id: 2,
            name: 'Twitter',
            imageUrl: '<img src="https://i.postimg.cc/mzt0LfkL/twitter.png" alt="twitter" height="36"/>',
            markdownUrl: '[![twitter.png](https://i.postimg.cc/vBzMvGdV/twitter.png)](https://postimg.cc/mzt0LfkL)',
            value: '',
            url: 'https://twitter.com/'
        },
    ],
    changeData: () => { },
    about: [
        {
            id: 0,
            name: 'work',
            description: '🔭  I’m currently working on ',
            link: '',
            value: '',
            placeholder: 'project name'
        },
        {
            id: 1,
            name: 'collab',
            description: '👯  I’m looking to collaborate on ',
            link: '',
            value: '',
            placeholder: 'project name'
        },
        {
            id: 2,
            name: 'projects',
            description: '👨‍💻  All of my projects are available at ',
            link: '',
            value: '',
            placeholder: 'source'
        },
        {
            id: 3,
            name: 'article',
            description: '📝  I regularly create tutorial on',
            link: '',
            value: '',
            placeholder: 'source'
        },
        {
            id: 4,
            name: 'askme',
            description: '💬  Ask me about',
            link: '',
            value: '',
            placeholder: 'anything'
        },
        {
            id: 5,
            name: 'reachme',
            description: '📫  How to reach me',
            link: '',
            value: '',
            placeholder: 'social media or email'
        },
        {
            id: 6,
            name: 'experience',
            description: '📄  Know about my experiences on',
            link: '',
            value: '',
            placeholder: 'LinkedIn or portfolio website'
        },
        {
            id: 7,
            name: 'funFact',
            description: '⚡ Fun fact',
            link: '',
            value: '',
            placeholder: 'anything about you'
        },
    ],
};

const AppContext = React.createContext<IAppContext>(defaultState);

export { AppContext, defaultState };
export type { IAppContext };
